import _ from 'lodash'
import { useMemo } from 'react'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { z } from 'zod'

import { Tab, Tabs } from '@mui/material'

import { useQueryParam } from '@/hooks/useQueryParam'

export enum AdminEstablishmentTabEnum {
  EDIT = 'edit',
  PLUGINS = 'plugins',
}

function validateEstablishmentTab(value: string | null) {
  return z.nativeEnum(AdminEstablishmentTabEnum).catch(AdminEstablishmentTabEnum.EDIT).parse(value)
}

export function useEstablishmentTab() {
  const [tab] = useQueryParam('tab', validateEstablishmentTab)
  return tab
}

export function EstablishmentTabs() {
  const lingui = useLingui()

  const [tab, setTab] = useQueryParam('tab', validateEstablishmentTab)

  const tabs = useMemo(
    () => [
      { id: 'edit', label: lingui._(t`Edit`), value: AdminEstablishmentTabEnum.EDIT },
      { id: 'plugins', label: lingui._(t`Plugins`), value: AdminEstablishmentTabEnum.PLUGINS },
    ],
    [lingui]
  )

  return (
    <Tabs value={tab} onChange={(_event, newValue) => setTab(newValue)} variant="scrollable">
      {_.map(tabs, (tab) => (
        <Tab key={tab.id} label={tab.label} value={tab.value} />
      ))}
    </Tabs>
  )
}
